import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import { PaidRounded } from '@mui/icons-material';
import { softTints } from '../../constants/uiTokens';
import Txt from './Txt';

const STATE_TINT = { ok: softTints.success, low: softTints.warning, zero: softTints.error };

/**
 * CreditChip — chip de créditos no header da página (sempre visível). Muda de cor
 * conforme o saldo (ok / baixo / zero) e traz o atalho "Comprar". Traduzido do mockup.
 */
export default function CreditChip({ balance = 0, state = 'ok', onBuy }) {
  const c = STATE_TINT[state] || softTints.success;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        bgcolor: c.bg,
        border: '1px solid',
        borderColor: c.border,
        borderRadius: '10px',
        pl: 1.75,
        pr: 1.25,
        py: 1,
      }}
    >
      <PaidRounded sx={{ fontSize: 20, color: c.main }} />
      <Box sx={{ lineHeight: 1.15 }}>
        <Txt sx={{ fontSize: 10, fontWeight: 600, letterSpacing: '.04em', textTransform: 'uppercase', color: c.sub }}>
          Créditos
        </Txt>
        <Txt sx={{ fontSize: 16, fontWeight: 700, color: c.fg }}>
          {Number(balance).toLocaleString('pt-BR')}
        </Txt>
      </Box>
      <Button
        onClick={onBuy}
        disableElevation
        sx={{
          bgcolor: '#fff',
          color: c.fg,
          border: '1px solid',
          borderColor: c.border,
          borderRadius: '7px',
          px: 1.5,
          py: 0.5,
          fontSize: '12.5px',
          fontWeight: 600,
          minWidth: 0,
          whiteSpace: 'nowrap',
          '&:hover': { bgcolor: '#fff', borderColor: c.fg },
        }}
      >
        Comprar
      </Button>
    </Box>
  );
}

CreditChip.propTypes = {
  balance: PropTypes.number,
  state: PropTypes.oneOf(['ok', 'low', 'zero']),
  onBuy: PropTypes.func.isRequired,
};
